import ReactQuill, { Quill } from "react-quill-new";
import { useEffect, useContext, useRef } from "react";
import Delta from "quill-delta";
import "react-quill-new/dist/quill.snow.css";
// @ts-ignore
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";
import "./PageEditor.less";
import { AppContext, sendMessage } from "../Context";

Quill.register({ "modules/table-better": QuillTableBetter }, true);

// document.addEventListener("copy", function (e) {
//   var text = window.getSelection()?.toString().replace(/\n\n/g, "\n") || "";
//   e.clipboardData?.setData("text/plain", text);
//   e.preventDefault();
// });

const win = global as any;

class QuillEditor extends ReactQuill {
  getEditorConfig(): ReactQuill.QuillOptions {
    const m = super.getEditorConfig();
    return {
      ...m,
      debug: win.location.hostname === "localhost" ? undefined : false,
      modules: {
        ...m.modules,
        toolbar: `#${this.props.id} .editToolbar`,
        table: false,
        "table-better": {
          language: "zh_CN",
          menus: [
            "column",
            "row",
            "merge",
            "table",
            "cell",
            "wrap",
            "copy",
            "delete",
          ],
          toolbarTable: true,
        },
        keyboard: {
          bindings: QuillTableBetter.keyboardBindings,
        },
      },
    };
  }

  renderEditingArea(): JSX.Element {
    const properties = {
      // key: this.state.generation,
      ref: this.editingAreaRef,
    };
    return (
      <div className="ep-quill-editor">
        <div className="editToolbar">
          <span className="ql-formats">
            <select className="ql-header" title="标题">
              {/* <option value="1"></option>
              <option value="2"></option>
              <option value="3"></option>
              <option value=""></option> */}
            </select>

            <select className="ql-color" title="字体颜色">
              {/* <option value="#ff7473"></option>
              <option value="#f9c00c"></option>
              <option value="#79bd9a"></option>
              <option value="#47b8e0"></option>
              <option value="#263959"></option>
              <option value="#d0d1d2"></option>
              <option value=""></option> */}
            </select>
            <select className="ql-background" title="背景色">
              {/* <option value="#ff7473"></option>
              <option value="#f9c00c"></option>
              <option value="#79bd9a"></option>
              <option value="#47b8e0"></option>
              <option value="#263959"></option>
              <option value="#d0d1d2"></option>
              <option value=""></option> */}
            </select>

            <button type="button" className="ql-bold" title="粗体"></button>
            <button type="button" className="ql-italic" title="斜体"></button>
            <button type="button" className="ql-strike" title="删除线"></button>
            <button
              type="button"
              className="ql-underline"
              title="下划线"
            ></button>
            <button type="button" className="ql-link" title="超链接"></button>
            <button type="button" className="ql-image" title="图片"></button>
            {/* <button type="button" className="ql-video"></button> */}
            <button
              type="button"
              className="ql-blockquote"
              title="引用"
            ></button>
            <button
              type="button"
              className="ql-code-block"
              title="代码块"
            ></button>

            <button
              type="button"
              className="ql-list"
              value="ordered"
              title="有序列表"
            ></button>
            <button
              type="button"
              className="ql-list"
              value="bullet"
              title="无序列表"
            ></button>
            <button
              type="button"
              className="ql-indent"
              value="-1"
              title="减少缩进"
            ></button>
            <button
              type="button"
              className="ql-indent"
              value="+1"
              title="增加缩进"
            ></button>

            {/* <select className="ql-size"></select> */}

            <button
              type="button"
              className="ql-table-better"
              title="插入表格"
            ></button>

            <button
              type="button"
              className="ql-clean"
              title="清除格式"
            ></button>
          </span>
        </div>

        <div className="editContainer">
          <div className="editContainerContent" {...properties}></div>
        </div>
      </div>
    );
  }
}

export function PageEditor({
  id,
  value,
  onChange,
  onPageSplit,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onPageSplit: (value: {
    startIndex: number;
    delta: Delta;
    text: string;
    focus: boolean;
  }) => void;
}) {
  const quillRef = useRef<QuillEditor>(null);
  const { onMessage } = useContext(AppContext);

  useEffect(() => {
    if (quillRef.current) {
      return onMessage(
        (pid: string, content: string | Delta | undefined, position, focus) => {
          if (id !== pid) {
            if (focus) {
              const editor = quillRef.current!.getEditor();
              const module = editor.getModule("table-better") as any;
              module.hideTools();
            }
            return;
          }
          if (position === "none") return;
          const editor = quillRef.current!.getEditor();
          let index = 0;
          let delta;
          if (position === "after") {
            index = editor.getText() === "\n" ? 0 : editor.getLength();
            delta =
              content instanceof Delta
                ? content
                : editor.clipboard.convert({ html: content });
            // 获取编辑器内容的尾部索引
            delta.ops.splice(0, 0, { retain: index });
          } else if (position === "before") {
            delta =
              content instanceof Delta
                ? content
                : editor.clipboard.convert({ html: content });
            delta.ops.splice(0, 0, { retain: 0 });
            // delta.insert("\n");
          } else {
            delta =
              content instanceof Delta
                ? content
                : editor.clipboard.convert({ html: content });
            const len = editor.getLength();
            delta.ops.splice(0, 0, { retain: 0 }, { delete: len });
          }
          editor.updateContents(delta, Quill.sources.USER);
          // 可选：将光标移到插入内容的末尾
          if (focus) {
            editor.setSelection(index + delta.length());
          }
        }
      );
    }
  }, [quillRef, onMessage, id]);

  useEffect(() => {
    // 监听内容变化事件（text-change）
    if (quillRef.current) {
      const editor = quillRef.current!.getEditor();
      let timer: NodeJS.Timeout | null = null;
      const handler = (_delta: any, _oldDelta: any, source: string) => {
        if (source !== "user") return;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          const index = editor.getSelection()?.index;
          const editContainer = editor.container.querySelector(
            ".ql-editor"
          ) as HTMLElement;
          const scrollHeight = editContainer.scrollHeight;
          const offsetHeight = editor.container.offsetHeight;
          if (scrollHeight > offsetHeight) {
            const editorRect = editor.container.getBoundingClientRect();
            const editorBottom = editorRect.bottom;
            const contentLength = editor.getLength(); // 内容总长度
            let overflowStartIndex = -1; // 溢出内容的起始索引

            // 遍历所有内容索引，找到第一个溢出的叶子节点的索引
            for (let i = 0; i < contentLength; i++) {
              // 通过索引获取内容叶子节点的 DOM 位置
              const [leaf] = editor.getLeaf(i); // 获取指定索引的叶子节点
              const domNode = leaf!.parent.domNode;
              const leafRect = domNode.getBoundingClientRect();
              if (leafRect.bottom > editorBottom) {
                overflowStartIndex = i;
                break;
              }
            }

            if (overflowStartIndex === -1) {
              return;
            }

            // 从溢出起始索引开始，提取 Delta 内容（保留完整格式）
            const fullDelta = editor.getContents();
            const overflowDelta = fullDelta.slice(overflowStartIndex); // 分割 Delta
            const overflowText = editor.getSemanticHTML(overflowStartIndex);

            process.env.NODE_ENV === "development" &&
              console.log(overflowStartIndex, overflowDelta, overflowText);

            // 删除溢出的 Delta
            editor.deleteText(overflowStartIndex, editor.getLength());

            onPageSplit({
              startIndex: overflowStartIndex,
              delta: overflowDelta,
              text: overflowText, // 溢出纯文本
              focus: overflowStartIndex > index!,
            });
          }
        }, 0);
      };
      editor.on("text-change", handler);
      return () => {
        editor.off("text-change", handler);
      };
    }
  }, [quillRef, onPageSplit]);

  useEffect(() => {
    sendMessage(id, value, "replace", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="ep-content-editor">
      <QuillEditor
        id={"p" + id}
        ref={quillRef}
        theme="snow"
        onFocus={() => {
          sendMessage(id, "", "none", true);
        }}
        onChange={(txt) => {
          onChange(txt);
        }}
      ></QuillEditor>
    </div>
  );
}
